import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getclaimFee = params => {
  return axios.request({
    url: "/cost/bill",
    method: "get",
    params
  });
};

// 获取详情
export const getclaimFeeDetail = params => {
  return axios.request({
    url: "/cost/bill/" + params.id,
    method: "get",
    params
  });
};

// 更新
export const updateClaimFee = data => {
  return axios.request({
    url: "/cost/bill/" + data.id,
    method: "put",
    data
  });
};

// 更新
export const delClaimFee = id => {
  return axios.request({
    url: "/cost/bill/" + id,
    method: "delete"
  });
};

// 确认账单
export const confirmClaimFee = id => {
  return axios.request({
    url: "/cost/bill/confirm/" + id,
    method: "post"
  });
};

// 汇率
export const getExchangeRate = data => {
  return axios.request({
    url: "/cost/bill/resetAmount/" + data.id,
    method: "post",
    data
  });
};

// 核销
export const writeOff = data => {
  return axios.request({
    url: "/cost/bill/writeOff/" + data.id,
    method: "post",
    data:data.data
  });
};

// 移出
export const removeClaimFee = data => {
  return axios.request({
    url: "/finance/claimBill/remove/" + data.pid,
    method: "post",
    data
  });
};

// 添加
export const addClaimFee = data => {
  return axios.request({
    url: "/finance/claimBill/add/" + data.id,
    method: "post",
    data
  });
};

export const billDetail = data => {
  return axios.request({
    url: "/cost/bill/detail/" + data.id,
    method: "get",
    data
  });
};

export const writeOffDetail = data => {
  return axios.request({
    url: "/cost/bill/writeOffLog/" + data.id,
    method: "get",
    data
  });
};

export const batchDelete = data => {
  return axios.request({
    url: "/cost/bill/batchDelete",
    method: "post",
    data
  });
};

export const setAmount = data => {
  return axios.request({
    url: "/cost/bill/setAmount/"+data.id,
    method: "post",
    data
  });
};

export const addCost = data => {
  return axios.request({
    url: "/cost/bill/addCost/"+data.id,
    method: "post",
    data
  });
};


export const exportAmount = (data,id) => {
  return axios.request({
    url: "/cost/bill/exportAmount/"+id,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data: data,
  });
};
export const batchWriteOff = data => {
  return axios.request({
    url: "/cost/bill/batchWriteOff",
    method: "post",
    data:data
  });
};

export const billExport = data => {
  return axios.request({
    url: "/cost/bill/export/"+data.id,
    method: "post",
		data
  });
};

export const getBank = id => {
  return axios.request({
    url: "/common/bank",
    method: "post",
  });
};

export const extract = data => {
  return axios.request({
    url: "/cost/bill/extract/" + data.id,
    method: "get",
    data
  });
};

export const costDetail = data => {
  return axios.request({
    url: "/cost/bill/cost/" + data.id,
    method: "get",
    data
  });
};
